<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('enterprises')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/accounting/enterprise/datatables"
      :page_length="50"
      mode="grid"
      grid_class="is-col-min-10"
    >
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div>
            <div
              class="is-pulled-right has-text-primary"
              :data-tooltip="$t('new period')"
              @click="new_period(item)"
            >
              <span class="icon"><i class="fa fa-plus"></i></span>
            </div>
            <figure class="image is-64x64 m-auto">
              <img
                src="https://cdn-icons-png.flaticon.com/512/9166/9166850.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <div class="title is-5 has-text-centered">
                  {{ item.name }}
                </div>
                <div
                  class="subtitle is-6 has-text-centered"
                  v-if="
                    current_enterprise && current_enterprise.name == item.name
                  "
                >
                  <span class="tag is-primary is-medium">{{
                    $t("current enterprise")
                  }}</span>
                </div>
              </div>
            </div>
            <div
              class="content"
              v-if="item.accounting_periods && item.accounting_periods.length"
            >
              <div class="title is-5">{{ $t("periods") }}</div>
              <ul>
                <li
                  v-for="(period, pidx) in item.accounting_periods"
                  :key="pidx"
                >
                  <a :href="'/accounting/' + period.uuid">{{ period.name }}</a>
                  <div
                    class="is-pulled-right has-text-danger"
                    :data-tooltip="$t('delete')"
                    @click="delete_period(period)"
                  >
                    <span class="icon"><i class="fa fa-trash"></i></span>
                  </div>
                  <div
                    class="is-pulled-right has-text-warning"
                    :data-tooltip="$t('edit')"
                    @click="edit_period(period)"
                  >
                    <span class="icon"><i class="fa fa-edit"></i></span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div>
      </template>
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>
  <enterprise-modal ref="enterprise_modal" @success="refresh" />
  <period-modal ref="period_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import EnterpriseModal from "./enterprise_modal/Index.vue";
import PeriodModal from "./period_modal/Index.vue";

export default {
  name: "EnterpriseDatatable",
  components: { GenericTable, EnterpriseModal, PeriodModal },
  data() {
    let v = this;
    return {
      extra_buttons: [],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          // width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            if (row.behavior == "credit")
              return `<span class="icon has-text-success"><i class="fa fa-angle-right"></i></span> ${row.name}`;
            else if (row.behavior == "charge")
              return `<span class="icon has-text-danger"><i class="fa fa-angle-left"></i></span> ${row.name}`;
            else
              return `<span class="icon"><i class="fa fa-cubes"></i></span> ${row.name}`;
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.movement_type_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete movement type?"),
                    v,
                    () => {
                      del("/account/movement_type", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
      current_enterprise: {},
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.enterprise_modal.show_modal();
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete enterprise?"),
        v,
        () => {
          del("/accounting/enterprise", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    edit(item) {
      let v = this;
      v.$refs.enterprise_modal.edit_modal(item.uuid);
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    set_as_current(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to set this enterprise as current?"),
        v,
        () => {
          v.current_enterprise = item;
          v.$emit("set_as_current", item);
        }
      );
    },
    new_period(item) {
      let v = this;
      v.$refs.period_modal.show_modal(item);
    },
    select_period(period, enterprise) {
      let v = this;
      // console.log("select_period", period, enterprise);
      // v.$emit("select_period", { period, enterprise });
      v.$router.push({
        path: `/accounting/${period.uuid}`,
      });
    },
    delete_period(period) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete this period?"),
        v,
        () => {
          del("/accounting/period", { uuid: period.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    edit_period(period) {
      let v = this;
      v.$refs.period_modal.edit_modal(period.uuid);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
